import CustomsortIcon from '../../assets/Icons/SortIcon.svg';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

type CustomSortType = {
    isActive: boolean;
    direction: 'asc' | 'desc'
}

const sortIconStyles = {
    fontSize: '18px',
    color: '#0079BB',
    marginLeft: '6px'
};

const CustomSortIcon = ({ isActive, direction }: CustomSortType) => {
    if (!isActive)
        return <img src={CustomsortIcon} alt="Sort" />;

    if (direction === 'asc')
        return <ArrowUpwardIcon style={sortIconStyles} />;

    if (direction === 'desc')
        return <ArrowDownwardIcon style={sortIconStyles} />;
}

export default CustomSortIcon;